var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"AItemPrice"},[(_vm.price.inProgress && !_vm.forceStop)?[_c('a3-dots',{attrs:{"title":_vm.$t('dict.findingPrice')}})]:_vm._e(),[_vm._v(" "+_vm._s(_vm.price.price)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }